import styled, {css} from "styled-components"
import Card from "@irati/ui/src/experimental/Card"

interface WrapperProps {
  thumbnail: string
}

export const RentalPlaceholderWrapper = styled(Card)<WrapperProps>`
  ${({thumbnail}) => css`
    position: relative;
    background-image: url("${thumbnail}");
    background-size: cover;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 50%);
  `}
`

export const ArticleWrapper = styled(Card)<WrapperProps>`
  ${({thumbnail}) => css`
    position: relative;
    background-image: url("${thumbnail}");
    background-size: cover;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%;
  `}
`

export const RentalPlaceholderContent = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({theme}) => theme.spacing.five};
`
